import { Injectable } from '@angular/core';
import { MCConfigService, MCEnvironmentsService } from '@maslul/common-services';


@Injectable({ providedIn: 'root' })
export class EnvironmentsService extends MCEnvironmentsService {

    constructor(private configService: MCConfigService) {
        super();
    }

    isDevMode() {
        const env = this.configService.getConfiguration().rootSiteUrl;
        return env.includes('d.');
    }
    isTestMode() {
        const env = this.configService.getConfiguration().rootSiteUrl;
        return env.includes('t.');
    }

    isTestEnvironment() {
        const env = this.configService.getConfiguration().rootSiteUrl;
        return env.includes('t.') || env.includes('a.');
    }

    isProductionMode() {
        const env = this.configService.getConfiguration().rootSiteUrl;
        return !env.includes('d.') && !env.includes('t.') && !env.includes('s.');
    }

}
